import { baseGeospatial } from "../../../api/base/baseUrl";

const BASE_URL = "/api/v1/vehicle";

export async function getPricingVehicleListRequest() {
  const response = await baseGeospatial.get(`${BASE_URL}/get-all-list`);
  return response.data;
}

export async function getPricingVehicleByIdRequest(id) {
  const response = await baseGeospatial.get(`${BASE_URL}/get-by-id/${id}`);
  return response.data;
}

export async function createPricingVehicleRequest(payload) {
  const response = await baseGeospatial.post(BASE_URL, payload);
  return response.data;
}

export async function updatePricingVehicleRequest(payload) {
  const response = await baseGeospatial.put(`${BASE_URL}/update`, payload);
  return response.data;
}

export async function updatePricingVehicleOrderRequest(payload) {
  const response = await baseGeospatial.put(`${BASE_URL}/update-order`, payload);
  return response.data;
}

export async function deletePricingVehicleRequest(id) {
  const response = await baseGeospatial.delete(`${BASE_URL}/delete/${id}`);
  return response.data;
}
